<template>
  <div :class="[$.range]">
    <vgp-label-slot
      :label="locales('filter_number_type_custom_column_from')"
      :style="{marginBottom: '8px'}"
    >
      <template #body>
        <div :style="{display: 'flex'}">
          <vgp-date-picker
            :value="rangeValue.start"
            :has-footer-slot="false"
            :style="{width: '50%', marginRight: '8px'}"
            @onChange="handleChangeStartDate"
          >
            <template #default="{ inputValue, togglePopover }">
              <div @click.stop="() => togglePopover()">
                <vgp-input
                  ref="input"
                  :placeholder="locales('filter_number_type_custom_column_from')"
                  :value="inputValue"
                  :small="true"
                  :icons-left="[{name: 'calendar', type: 'regular', size: 24, handler: null}]"
                />
              </div>
            </template>
          </vgp-date-picker>
          <vgp-input
            ref="input"
            v-model="timeValue.from"
            :style="{width: '50%'}"
            :placeholder="locales('filter_number_type_custom_column_from')"
            :value="timeValue.from"
            :small="true"
            :icons-left="[{ name: 'time', handler: null }]"
            @onChange="onChangeTimeInput('from', $event.target.value)"
          />
        </div>
      </template>
    </vgp-label-slot>

    <vgp-label-slot
      :label="locales('filter_number_type_custom_column_to')"
    >
      <template #body>
        <div :style="{display: 'flex'}">
          <vgp-date-picker
            :value="rangeValue.end"
            :has-footer-slot="false"
            :style="{width: '50%', marginRight: '8px'}"
            @onChange="handleChangeEndDate"
          >
            <template #default="{ inputValue, togglePopover }">
              <div @click.stop="() => togglePopover()">
                <vgp-input
                  ref="input"
                  :placeholder="locales('filter_number_type_custom_column_to')"
                  :value="inputValue"
                  :small="true"
                  :icons-left="[{name: 'calendar', type: 'regular', size: 24, handler: null}]"
                />
              </div>
            </template>
          </vgp-date-picker>
          <vgp-input
            ref="input"
            v-model="timeValue.to"
            :style="{width: '50%'}"
            :placeholder="locales('filter_number_type_custom_column_to')"
            :readonly="readonly"
            :value="timeValue.to"
            :small="true"
            :icons-left="[{ name: 'time', handler: null }]"
            @onChange="onChangeTimeInput('to', $event.target.value)"
          />
        </div>
      </template>
    </vgp-label-slot>
  </div>
</template>
<script>
import vgpDatePicker from '../../common/VueComponents/datePicker/vgpDatePicker.vue';
import vgpInput from '../../common/VueComponents/vInput/vgpInput.vue';
import vgpLabelSlot from '../../common/VueComponents/label/vgpLabelSlot.vue';
import filterConstants from '../constants';
import timeParser from '../../../helpers/timeParser';

export default {
  components: { vgpDatePicker, vgpInput, vgpLabelSlot },
  props: {
    filterItems: { type: Array, required: false, default: () => [] },
  },
  emits: {
    changeFilter: Object,
  },
  data() {
    return {
      locales: __,
      rangeValue: { start: '', end: '' },
      timeValue: { from: '', to: '' },
    };
  },
  watch: {
    filterItem: {
      handler() {
        this.setValues();
      },
      immediate: true,
    },
  },
  created() {
    this.setValues();
  },
  methods: {
    setValues() {
      this.filterItems.forEach(item => {
        if (item.property === filterConstants.PROPERTY.date) {
          const value = item.value;

          if (!value || value === '') {
            this.rangeValue.start = new Date();
            this.rangeValue.end = new Date();
          } else {
            this.rangeValue.start = value?.start;
            this.rangeValue.end = value?.end;
          }
        }

        if (item.property === filterConstants.PROPERTY.time) {
          const value = item.value;

          if (!value || value === '') {
            this.timeValue.from = '';
            this.timeValue.to = '';
          } else {
            this.timeValue.from = timeParser.output(value?.from);
            this.timeValue.to = timeParser.output(value?.to);
          }
        }
      });
    },
    handleChangeStartDate(val) {
      const value = {
        start: val,
        end: this.rangeValue.end,
      };

      const changes = {
        [filterConstants.PROPERTY.date]: value,
      };

      this.$emit('changeFilter', changes);
    },
    handleChangeEndDate(val) {
      const value = {
        start: this.rangeValue.start,
        end: val,
      };

      const changes = {
        [filterConstants.PROPERTY.date]: value,
      };

      this.$emit('changeFilter', changes);
    },
    onChangeTimeInput(prop, val) {
      const valid = timeParser.input(val).value;

      if (!valid) {
        this.timeValue = {
          ...this.timeValue,
          [prop]: '',
        };

        return;
      }

      const time = {
        ...this.timeValue,
        [prop]: valid,
      };

      const changes = {
        [filterConstants.PROPERTY.time]: time,
      };

      this.timeValue[prop] = timeParser.output(valid);
      this.$emit('changeFilter', changes);
    },
  },
};
</script>
<style module='$' lang='less'>
.range {}
</style>
